var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: "loading-modal",
            "no-close-on-esc": "",
            "no-close-on-backdrop": "",
            "hide-header-close": "",
            centered: "",
            title: "Even geduld..."
          },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function(ref) {
                return [_c("p")]
              }
            }
          ]),
          model: {
            value: _vm.isLoading,
            callback: function($$v) {
              _vm.isLoading = $$v
            },
            expression: "isLoading"
          }
        },
        [
          _c("div", [
            _c(
              "div",
              { staticClass: "d-flex justify-content-center mb-3" },
              [_c("b-spinner", { attrs: { label: "Even geduld..." } })],
              1
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "col-lg-8" }, [
        _c("div", { staticClass: "card shadow mb-4" }, [
          _c(
            "div",
            {
              staticClass:
                "card-header py-3 d-flex flex-row align-items-center justify-content-between"
            },
            [
              _c(
                "div",
                _vm._l(_vm.usedSeatCategories, function(item) {
                  return _c("div", [
                    _c("div", { staticClass: "box", class: item[1][1] }),
                    _vm._v(" "),
                    _c("div", [_vm._v(_vm._s(item[1][0]))])
                  ])
                }),
                0
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-primary text-right btn-sm",
                  attrs: { id: "bntZoom", type: "button" },
                  on: { click: _vm.zoomOut }
                },
                [_vm._v("Uitzoomen\n          ")]
              )
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "card-body" }, [
            _c("div", {
              attrs: { id: "seatplan_div" },
              domProps: { innerHTML: _vm._s(_vm.seatPlan) }
            })
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-lg-4" }, [
        _c("div", { staticClass: "card shadow mb-4" }, [
          _c("div", { staticClass: "card-body mt-0" }, [
            _vm.isLoading === false
              ? _c("div", { staticClass: "card text-center" }, [
                  _c("div", { staticClass: "card-body" }, [
                    _c("h5", { staticClass: "card-title" }, [
                      _vm._v("Aantal tickets: " + _vm._s(_vm.selection.length))
                    ]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "btn btn-primary",
                        attrs: { href: "/my/cart" }
                      },
                      [_vm._v("Winkelkar")]
                    )
                  ])
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _vm.selection.length > _vm.pageSize
            ? _c("nav", [
                _c("ul", { staticClass: "pagination justify-content-center" }, [
                  _c(
                    "li",
                    {
                      staticClass: "page-item",
                      class: { disabled: _vm.getCurrentStartIndex() === 0 }
                    },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "page-link",
                          attrs: { href: "#" },
                          on: { click: _vm.onPagePrevious }
                        },
                        [_vm._v("Vorige")]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    {
                      staticClass: "page-item",
                      class: {
                        disabled:
                          _vm.getCurrentStartIndex() >=
                          _vm.selection.length - _vm.pageSize
                      }
                    },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "page-link",
                          attrs: { href: "#" },
                          on: { click: _vm.onPageNext }
                        },
                        [_vm._v("Volgende")]
                      )
                    ]
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "ul",
            { staticClass: "list-group mb-3" },
            _vm._l(
              _vm.selection.slice(
                _vm.getCurrentStartIndex(),
                _vm.getCurrentStartIndex() + _vm.pageSize
              ),
              function(item, index) {
                return _c(
                  "li",
                  { key: item.seatCode, staticClass: "list-group-item" },
                  [
                    _vm.isReadOnly
                      ? _c("reservation-item-readonly", {
                          attrs: {
                            selectedItem: item,
                            index: index + _vm.getCurrentStartIndex()
                          },
                          on: {
                            "priceconfig-changed": _vm.onPriceConfigChanged,
                            seatFreedEvent: _vm.HandleSeatFreedSelectedEvent
                          }
                        })
                      : _c("reservation-item", {
                          attrs: {
                            selectedItem: item,
                            index: index + _vm.getCurrentStartIndex()
                          },
                          on: {
                            "priceconfig-changed": _vm.onPriceConfigChanged,
                            seatFreedEvent: _vm.HandleSeatFreedSelectedEvent
                          }
                        })
                  ],
                  1
                )
              }
            ),
            0
          ),
          _vm._v(" "),
          _vm.selection.length > _vm.pageSize
            ? _c("nav", [
                _c("ul", { staticClass: "pagination justify-content-center" }, [
                  _c(
                    "li",
                    {
                      staticClass: "page-item",
                      class: { disabled: _vm.getCurrentStartIndex() === 0 }
                    },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "page-link",
                          attrs: { href: "#" },
                          on: { click: _vm.onPagePrevious }
                        },
                        [_vm._v("Vorige")]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    {
                      staticClass: "page-item",
                      class: {
                        disabled:
                          _vm.getCurrentStartIndex() >=
                          _vm.selection.length - _vm.pageSize
                      }
                    },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "page-link",
                          attrs: { href: "#" },
                          on: { click: _vm.onPageNext }
                        },
                        [_vm._v("Volgende")]
                      )
                    ]
                  )
                ])
              ])
            : _vm._e()
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }